import React from "react";
import { Dialog } from "primereact/dialog";
import AddingNewDistrict from "../districtmaster/district-add";
 
interface AddDistrictProps {
  showAddUserModal: boolean;
  hideAddUserModal: () => void;
  handleAddSuccess: () => void;
}
 
const AddDistrict: React.FC<AddDistrictProps> = ({
  showAddUserModal,
  hideAddUserModal,
  handleAddSuccess
}) => {
  return (
    <Dialog
      visible={showAddUserModal}
      className="quickview"
      breakpoints={{ "1400px": "45vw", "641px": "80vw" }}
      modal
      onHide={hideAddUserModal}
 
    >
      <AddingNewDistrict
        showDistrictDialog={showAddUserModal}
        hideDistrictDialog={hideAddUserModal}
        handleAddSuccess={handleAddSuccess}
      />
    </Dialog>
  );
};
 
export default AddDistrict;
 
 